import { Controller } from "@hotwired/stimulus"

// Handles file upload form interactions.
// Enables submit button when a file is selected.
// Shows context field when a file is selected.
export default class extends Controller {
  static targets = ["input", "submit", "contextField"]

  fileSelected() {
    const hasFile = this.inputTarget.files.length > 0
    this.submitTarget.disabled = !hasFile

    this.contextFieldTargets.forEach(el => {
      el.classList.toggle("hidden", !hasFile)
    })
  }
}
